module.exports = __webpack_public_path__ + "static/media/circle-green.c30bb013.svg";